import { Routes, Route, Navigate } from 'react-router'

import LoginPage from '@features/login/LoginPage.container'
import SsoLoginPage from '@features/login/SsoLoginPage.container'
import OAuthErrorPage from '@features/oauth-error/OAuthErrorPage.container'
import InvitePage from '@features/invite/InvitePage.container'
import RecoveryPage from '@features/recovery/RecoveryPage.container'
import SettingsPage from '@features/settings/SettingsPage.container'
import VerificationPage from '@features/verification/VerificationPage.container'
import NotFoundPage from '@features/not-found/NotFoundPage.container'

const App = () => (
  <Routes>
    <Route path='/' element={<Navigate to='/login' replace={true} />} />
    <Route path='/login' element={<LoginPage />} />
    <Route path='/login/sso' element={<SsoLoginPage />} />
    <Route path='/error' element={<OAuthErrorPage />} />
    <Route path='/invite' element={<InvitePage />} />
    <Route path='/recovery' element={<RecoveryPage />} />
    <Route path='/settings' element={<SettingsPage />} />
    <Route path='/verification' element={<VerificationPage />} />
    <Route path='*' element={<NotFoundPage />} />
  </Routes>
)

export default App
